module.exports = __webpack_public_path__ + "static/media/image-19.cff5750c.png";